import { middlewareService } from '../../../../../../src/shared/service';

export const esigningUrl = {
    getEsigningUrl,
    getSavedKycDetails,
    saveKycDetails,
    checkIfESignDone
}

function getEsigningUrl(payload) {
    let _url = "/digioEsign/getEsigningUrl";
    return middlewareService.postApiData(_url, payload)
        .then(x => x)
        .catch(x => x);
}

function getSavedKycDetails(payload) {
    let _url = "/cvlKyc/getSavedKycForm";
    return middlewareService.postApiData(_url, payload)
        .then(x => x)
        .catch(x => x);
}

function saveKycDetails(payload) {
    let _url = "/cvlKyc/saveKycForm";
    return middlewareService.postApiData(_url, payload)
        .then(x => x)
        .catch(x => x);

}

function checkIfESignDone(pans) {
    //pans=["pan"]
    let promises = [];
    pans.forEach(pan => {
        promises.push(isEsignDroppedOff(pan));
    });

   return Promise.all(promises)
        .then(response => {
            if (response && response.length > 0) {
               return response.map((item, index) => {
                    item.pan = pans[index]
                    return item;
                })
            }
        });
}

function isEsignDroppedOff(pan) {
    let _url = "/users/isEsignDroppedOff";
    return middlewareService.postApiData(_url, { pan })
        .then(x => x)
        .catch(x => x);
}

